import classes from "../subPagesClasses.module.scss";
import { CustomerInsightOutletContext } from "../..";
import { useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import MessageBox from "components/elements/MessageBox";
import I18n from "components/materials/I18n";
import { EPatrimoineRevenusCorporationGroups } from "common/enums/Scpi/Corporation/Groups/EPatrimoineRevenusCorporationGroups";
import { getInputListSubPatrimoineRevenus } from "components/pages/Subscriptions/corporation/SubscriptionQuestionsCorporation/SubPatrimoineRevenusCorporation";

export default function CustomerInsightPatrimoineRevenus() {
	const { subscription, renderInputList } = useOutletContext<CustomerInsightOutletContext>();

	const [inputList, setInputList] = useState<Record<EPatrimoineRevenusCorporationGroups, JSX.Element | null> | null>(null);

	useEffect(() => {
		if (!subscription) return;
		setInputList(getInputListSubPatrimoineRevenus(subscription, true, true));
	}, [subscription]);

	if (!inputList || !subscription) return null;
	return (
		<div className={classes["root"]}>
			{!subscription.patrimoineRevenus && (
				<MessageBox className={classes["warning-prelevement"]} type="info" text={I18n.asset.pages.client.sub_pages.customer_insight.no_data} />
			)}
			{subscription.patrimoineRevenus && renderInputList(inputList)}
		</div>
	);
}
